import React, { useCallback, useEffect, useState } from 'react';
import './App.scss';
import CardsRoot from './components/CardsRoot';
import { ProductRepository } from './services/ProductRepository';
import { StorageHelper } from './services/Storage';

function App() {

  const isRequested = React.useRef(false);
  useEffect(() => {
    if (!isRequested.current) {
      isRequested.current = true;
      ProductRepository.fetchProducts();
    }
  }, [])

  const [windowSize, setWindowSize] = useState(StorageHelper.getLastWindowSize());
  const toScaleUp = useCallback(() => {
    if (windowSize === 'medium') {
      setWindowSize('large');
    } else if (windowSize === 'small') {
      setWindowSize('medium');
    }
  }, [windowSize]);

  const toScaleDown = useCallback(() => {
    if (windowSize === 'large') {
      setWindowSize('medium');
    } else if (windowSize === 'medium') {
      setWindowSize('small');
    }
  }, [windowSize]);

  useEffect(()=>{
    StorageHelper.saveWindowSize(windowSize);
  }, [windowSize]);

  return (
    <div className={`osica-card-builder-size-${windowSize}`}>
      <CardsRoot windowSize={windowSize} toScaleDown={toScaleDown} toScaleUp={toScaleUp} />
    </div>
  );
}

export default App;
